import { IConfig } from "./Render";

export const Thead = ({className, id, style, children}:IConfig)=>
{
    return (
        <thead id={id} className={className} style={style}>{children}</thead>
    );
}